import { Batch } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/batch/v1/batch.pb';
import { Campaign, Usage } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { FilterOptions_AppointmentQualifier } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/bulk.pb';
import { SchemaIO } from '@frontend/schema';
import { SchemaBulkMessagingService } from './service';

export { FilterOptions_AppointmentQualifier as AppointmentQualifier };

export type AudienceFilters = NonNullable<
  SchemaIO<(typeof SchemaBulkMessagingService)['CreateSegment']>['input']['segment']['filterOptions']
>;

export interface BulkUsageInfo {
  allotment: number;
  sentAndFailed: number;
  scheduled: number;
}

export type CampaignGroup = {
  month: number;
  campaigns: Campaign[];
  usage: Usage;
};

export const SMS_BETA_CAMPAIGN_TYPE = 'text-beta';

export type Draft = (Campaign & { campaignType: 'email' | 'text-beta' }) | (Batch & { campaignType: 'text' });
